import { useContext, createContext } from "react";
import { baseURL } from "../lib";
import { useAuth } from "./AuthContext";
import axios from 'axios'

const AuditContext = createContext()

const AuditProvider = ({ children }) => {

    const { toast, restaurantId, headers } = useAuth();

    const getAllAudits = async (filter) => {
        try {
            const { page, search, limit, sortField, sortOrder } = filter

            let { data } = await axios.get(`${baseURL}/user-audit/list?sortField=${sortField}&sortOrder=${sortOrder}&filter=${search ? search : null}&limit=${limit ? limit : null}&page=${page ? page : null}&restaurant_id=${restaurantId}`, { headers })
            
            if (data.error === false) {
                return data.data
            } else {
                toast.current?.show({ severity: 'error', summary: 'Audits', detail: data?.message, life: 3000 })
            }
        } catch (error) {
            console.log("error:", error);
            toast.current?.show({ severity: 'error', summary: 'Audits', detail: error?.response?.data?.message, life: 3000 })
        }
    }

    return (
        <AuditContext.Provider value={{ getAllAudits }}>
            {children}
        </AuditContext.Provider>
    )
}

const useAudit = () => useContext(AuditContext)

export { useAudit, AuditProvider }